














































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "@/plugins/axios";
import { Event, User } from "@/types";
import draggable from "vuedraggable";
import moment from "moment";
import { cloneDeep } from "lodash";
import AnimeSelector from "@/components/AnimeSelector/Event.vue";
import EventCardImage from "@/components/Event/EventCardImage.vue";
import { serialize } from "object-to-formdata";

@Component({
  components: { EventCardImage, AnimeSelector, draggable }
})
export default class EventModal extends Vue {
  @Prop() eventToEdit?: Event;
  @Prop() eventToClone?: Event;
  @Prop() next!: boolean;
  dialog = false;
  event: Event = {
    id: 0,
    title: "",
    media: [],
    start: moment(),
    end: moment()
  } as Event;
  loading = false;
  streamers: User[] = [];
  tab = "details";
  error = "";
  image: File | null = null;
  discordImage: File | null = null;

  get imagePreview() {
    if (this.image) {
      return URL.createObjectURL(this.image);
    }
    return this.event.image;
  }

  resetImage() {
    this.image = null;
    this.event.image = "";
  }

  get discordImagePreview() {
    if (this.discordImage) {
      return URL.createObjectURL(this.discordImage);
    }
    return this.event.discordImage;
  }

  resetdiscordImage() {
    this.discordImage = null;
    this.event.discordImage = "";
  }

  mounted() {
    this.getStreamers();
    if (this.eventToClone) {
      this.clone();
    }
    if (this.eventToEdit) {
      this.event = this.eventToEdit;
    }
  }

  itemValue(user: User) {
    return user;
  }

  getStreamers() {
    axios
      .get("/api/user/streamers")
      .then((response: { data: User[] }) => {
        this.streamers = response.data;
      })
      .catch((error: object) => {
        console.log(error);
        this.error = "Unable to retrieve streamers.";
      });
  }

  clone() {
    if (this.eventToClone) {
      this.event = cloneDeep(this.eventToClone);
      this.event.start = this.eventToClone.start.clone();
      this.event.end = this.eventToClone.end.clone();
      if (this.next) {
        this.event.start.add(1, "week");
        this.event.end.add(1, "week");
        this.event.media = this.event.media.filter(
          media =>
            !(
              media.EventMedia &&
              media.episodes &&
              media.EventMedia.episode + media.EventMedia.episodes >
                media.episodes
            )
        );
        for (const media of this.event.media) {
          if (media.EventMedia) {
            media.EventMedia.episode =
              media.EventMedia.episode + media.EventMedia.episodes;
            if (media.episodes) {
              if (
                media.EventMedia.episode + media.EventMedia.episodes - 1 >
                media.episodes
              ) {
                media.EventMedia.episodes =
                  media.episodes - media.EventMedia.episode + 1;
              }
            }
          }
        }
      }
    }
  }

  get start() {
    return this.event.start.toDate();
  }

  set start(date) {
    this.form.resetValidation();
    this.event.start = moment(date);
  }

  get end() {
    return this.event.end.toDate();
  }

  set end(date) {
    this.form.resetValidation();
    this.event.end = moment(date);
  }

  get form() {
    return (this.$refs.form as unknown) as {
      reset(): void;
      resetValidation(): void;
      validate(): boolean;
    };
  }

  close() {
    this.dialog = false;
    if (this.eventToEdit) {
      this.form.resetValidation();
    } else if (this.eventToClone) {
      this.clone();
    } else {
      this.form.reset();
      this.event.media = [];
    }
    this.$emit("close");
  }

  save() {
    if (this.form.validate()) {
      this.loading = true;
      const data: {
        json: string;
        image: File | null;
        discordImage: File | null;
      } = {
        json: JSON.stringify(this.event),
        image: this.image,
        discordImage: this.discordImage
      };
      if (this.eventToEdit) {
        axios
          .post("/api/schedule", serialize(data))
          .then(() => {
            this.close();
            this.loading = false;
            this.$emit("save");
          })
          .catch(e => {
            if (e.response && e.response.data && e.response.data.message) {
              this.error = e.response.data.message;
            } else {
              this.error = "Something went wrong. Please try again later.";
            }
            this.loading = false;
          });
      } else {
        axios
          .put("/api/schedule", serialize(data))
          .then(() => {
            this.close();
            this.loading = false;
            this.$emit("save");
          })
          .catch(e => {
            if (e.response && e.response.data && e.response.data.message) {
              this.error = e.response.data.message;
            } else {
              this.error = "Something went wrong. Please try again later.";
            }
            this.loading = false;
          });
      }
    }
  }
}
